<template>
  <section class="page-section" v-loading="pageLoading">
        <!-- 步骤条 -->
        <div class="steps-bar flex-h">
          <div :class="[step == 1 ? 'steps-item flex-a-i active' : 'steps-item flex-a-i']">step1：编辑基本信息</div>
          <div :class="[step == 2 ? 'steps-item flex-a-i active' : 'steps-item flex-a-i']">step2：编辑项目详情</div>
        </div>

        <!-- step 1 -->
        <div class="step-content" v-show="step == 1">
          <el-form size="small" ref="formData" :model="formData" label-width="150px" class="content-form">
            <!-- 基本信息 -->
            <div class="form-module">
              <div class="module-header">基本信息</div>
              <div class="module-body">
                <el-form-item label="项目名称" required :show-message="false">
                  <el-input v-model="formData.baseInfo.name" class="w400" maxlength="100"
                    placeholder="中/英文字符、符号，不超过100个中文字符" @blur="handleValidGoodsName"></el-input>
                </el-form-item>
                <el-form-item label="尘峰项目编码" :show-message="false">
                  <el-input v-model="formData.baseInfo.externalGoodsCode" class="w400"
                    @input="formData.baseInfo.externalGoodsCode = formData.baseInfo.externalGoodsCode.replace(/[^a-zA-Z0-9]/g, '')"></el-input>
                </el-form-item>
                <div class="delete-block w465 delete-block-category"
                  v-for="(cateItem, cateIndex) in formData.baseInfo.categoryList" :key="cateIndex">
                  <div class="icon-delete" @click="handleCategoryDelete(cateIndex)"
                    v-if="formData.baseInfo.categoryList.length > 1"></div>
                  <el-form-item label="一级分类" required :show-message="false">
                    <el-select filterable v-model="cateItem.firstCategoryId" placeholder="" class="w150"
                      @change="handleFirstCategoryChange(cateIndex, 'user')">
                      <el-option v-for="item in firstCategoryOptions" :key="item.id" :label="item.name"
                        :value="'' + item.id"></el-option>
                    </el-select>
                    <el-button type="text" @click="getFirstCategoryList(true)"
                      :loading="firstCategoryOptionsLoading">刷新</el-button>
                    <router-link target="_blank" class="router-link-active"
                      :to="{ path: '/shop/component/list', query: { name: 1 } }">新建分类</router-link>
                  </el-form-item>
                  <el-form-item label="二级分类" required :show-message="false">
                    <el-select filterable v-model="cateItem.secondCategoryId" placeholder="" class="w150">
                      <el-option v-for="item in cateItem.secondCategoryOptions" :key="item.id" :label="item.name"
                        :value="'' + item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <!-- <el-form-item label="">
                                    <el-button size="small" type="default" plain @click="handleCategoryAdd">添加分类</el-button>
                                </el-form-item> -->
                <el-form-item label="主图视频" :show-message="false">
                  <div class="pics-box">
                    <template v-if="uploadVideoList.length === 0">
                      <el-upload :action="uploadPicUrl" list-type="picture-card" :file-list="uploadVideoList"
                        accept=".mp4,.mov" drag :on-preview="handleVideosPreview" :on-remove="handleVideosRemove"
                        :on-success="handleVideosSuccess" :on-error="handleVideosError"
                        :before-upload="handleVideosBeforeUpload" :on-exceed="handleVideosExceed" :limit="videosLimit">
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </template>
                    <template v-else>
                      <div class="video-box">
                        <template v-for="(row, rowIndex) in uploadVideoList">
                          <div class="video-item" :key="rowIndex">
                            <video :src="row.response.data.path" class="video"></video>
                            <div class="mask">
                              <i class="el-icon-zoom-in" @click.stop="handleVideosPreview"></i>
                              <i class="el-icon-delete" @click.stop="handleVideosRemove"></i>
                            </div>
                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                  <p class="tips">支持MP4、MOV格式，分辨率不低于720P，时长不超过30秒，大小不超过500MB。</p>
                  <p class="tips">视频高宽比为1：1，建议尺寸：800*800像素，最多上传1个。</p>
                </el-form-item>
                <el-form-item label="项目图片" required :show-message="false">
                  <div class="pics-box pics-box-goods">
                    <el-upload :action="uploadPicUrl" list-type="picture-card" :file-list="uploadPicList"
                      accept=".png,.jpg,.jpeg" drag :on-preview="handlePicturesPreview"
                      :on-remove="handlePicturesRemove" :on-success="handlePicturesSuccess"
                      :on-error="handlePicturesError" :before-upload="handlePicturesBeforeUpload"
                      :on-exceed="handlePicturesExceed" :limit="picsLimit">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                  <p class="tips">支持jpg、png格式，建议尺寸：800*800像素，可以拖拽图片调整顺序，最多上传6张。</p>
                </el-form-item>
                <el-form-item label="标签">
                  <span class="input-delete-wrap" v-for="(item, index) in formData.baseInfo.tags" :key="index">
                    <el-input v-model="item.label" class="w120" maxlength="8" placeholder="2-8个中文字符"></el-input>
                    <div class="btn-delete" @click="handleTagsDelete(index)"></div>
                  </span>
                  <el-button type="text" size="small" @click="handleTagsAdd()"
                    v-if="formData.baseInfo.tags.length < 4">添加标签</el-button>
                </el-form-item>
                <el-form-item label="备注" required :show-message="false">
                  <el-input v-model="formData.baseInfo.remark" class="w400" maxlength="50"
                    placeholder="中/英文字符、符号，不超过50个中文字符"></el-input>
                </el-form-item>
                <el-form-item label="预约方式" required :show-message="false">
                  <el-input type="textarea" rows="4" v-model="formData.baseInfo.orderType" class="w400" maxlength="50"
                    placeholder="中/英文字符、符号，不超过50个中文字符"></el-input>
                </el-form-item>
                <el-form-item label="价格" required :show-message="false">
                  <template v-if="unit == 1">
                    <el-input type="number" v-model="formData.baseInfo.koreaPrice" class="w150"
                      @change="handlePriceChange">
                      <template slot="prepend">
                        <el-select v-model="unit" @change="handlePriceUnitSwitch">
                          <template v-for="(row, rowIndex) in unitOptions">
                            <el-option :value="row.value" :label="row.label" :key="rowIndex"></el-option>
                          </template>
                        </el-select>
                      </template>
                    </el-input>
                  </template>
                  <template v-else>
                    <el-input type="number" v-model="formData.baseInfo.price" class="w150" @change="handlePriceChange">
                      <template slot="prepend">
                        <el-select v-model="unit" @change="handlePriceUnitSwitch">
                          <template v-for="(row, rowIndex) in unitOptions">
                            <el-option :value="row.value" :label="row.label" :key="rowIndex"></el-option>
                          </template>
                        </el-select>
                      </template>
                    </el-input>
                  </template>
                </el-form-item>
                <el-form-item label="汇率（人民币兑韩元）">
                  <el-input type="number" v-model.number="cnyToKrwRate" step="0.01" class="w150"
                    @change="handleCnyToKrwRateChange"></el-input>
                </el-form-item>
                <!-- <el-form-item label="划线价">
                                    <el-input type="number" v-model="formData.baseInfo.nickPrice" class="w150">
                                        <template slot="prepend">
                                            <el-select v-model="unit" disabled>
                                                <template v-for="(row, rowIndex) in unitOptions">
                                                    <el-option :value="row.value" :label="row.label" :key="rowIndex"></el-option>
                                                </template>
                                            </el-select>
                                        </template>
                                    </el-input>
                                </el-form-item> -->
                <el-form-item label="销售量" :show-message="false">
                  <el-input type="number" v-model="formData.baseInfo.saleNum" class="w150" :min="0"></el-input>
                </el-form-item>
                <el-form-item label="库存" required :show-message="false">
                  <el-input type="number" v-model="formData.baseInfo.stock" class="w150" :min="0"></el-input>
                  <p class="tips">库存为 0 时，会放到 [已售罄] 的项目列表里</p>
                </el-form-item>
              </div>
            </div>

            <div class="form-button-wrap">
              <el-button type="primary" size="small" @click="handleChangeStep(2)">下一步</el-button>
            </div>
          </el-form>
        </div>

        <!-- step 2 -->
        <div class="step-content" v-show="step == 2">
          <el-form size="small" ref="detailFormData" label-width="150px" class="content-form">
            <!-- 基本信息 -->
            <div class="form-module">
              <div class="module-header">项目详情</div>
              <div class="module-body">
                <el-form-item label="详情图" required :show-message="false">
                  <div class="pics-box pics-box-detail">
                    <el-upload :action="uploadPicUrl" list-type="picture-card" :file-list="detailUploadPicList"
                      accept=".png,.jpg,.jpeg" drag :on-preview="handleDetailPicturesPreview"
                      :on-remove="handleDetailPicturesRemove" :on-success="handleDetailPicturesSuccess"
                      :on-error="handleDetailPicturesError" :before-upload="handleDetailPicturesBeforeUpload">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                  <p class="tips">支持jpg、png格式，上传数量不限，单张图片不超过500k</p>
                </el-form-item>
              </div>
            </div>

            <div class="form-button-wrap">
              <el-button type="default" size="small" @click="handleChangeStep(1)">上一步</el-button>
              <el-button type="primary" size="small" @click="handleFormSubmit('formData')"
                :loading="submitLoading">保存</el-button>
            </div>
          </el-form>
        </div>

      

    <!-- 图片预览 -->
    <el-dialog :visible.sync="previewDialogShow" custom-class="preview-image-dialog">
      <img width="100%" :src="previewDialogImageUrl" alt="">
    </el-dialog>

    <!-- 视频预览 -->
    <el-dialog :visible.sync="previewVideoDialogShow" custom-class="preview-video-dialog">
      <video width="100%" style="height: calc(70vh - 60px)" :src="previewVideoDialogUrl" controls alt=""></video>
    </el-dialog>
      </section>
</template>

<script>
import { BASE, commodityCategoryList, serviceManageSaveOrUpdate, serviceManageDetail, validGoodsName, commodityGetLatestRate } from '@/common/api'

export default {
  name: 'goodsManageAdd',
  data() {
    return {
      id: this.$route.query.id || '',
      pageLoading: true,

      step: 1, // 当前步骤

      formData: { // 表单数据
        baseInfo: { // 基本信息
          name: '', // 商品名
          externalGoodsCode: '', // 尘峰项目编码
          categoryList: [
            {
              firstCategoryId: '',
              secondCategoryId: '',
              secondCategoryOptions: []
            }
          ],
          pics: [], // 图
          tags: [
            {
              label: ''
            }
          ], // 标签
          remark: '', // 备注
          orderType: '', // 预约方式
          price: '', // 价格
          nickPrice: '', //划线价
          saleNum: '', // 销售量
          stock: '', // 库存
        }
      },
      submitLoading: false,

      unit: 0,
      unitOptions: [
        {
          value: 0,
          label: '￥'
        },
        {
          value: 1,
          label: '₩'
        }
      ],

      firstCategoryOptions: [], // 商品类目列表
      firstCategoryOptionsLoading: true,

      uploadPicUrl: BASE + '/commodity/uploadPic', // 图片上传地址
      previewDialogShow: false,
      previewDialogImageUrl: '',
      previewVideoDialogShow: false,
      previewVideoDialogUrl: '',
      // 主图视频
      videosLimit: 1,
      uploadVideoList: [],
      // 商品图
      picsLimit: 6,
      uploadPicList: [],
      // 详情图片
      detailPics: [],
      detailUploadPicList: [],

      latestRateOrigin: 1,
      latestRate: 1, // 存储：1韩元 = latestRate人民币
      cnyToKrwRate: 1.00 // 显示：1人民币 = cnyToKrwRate韩元
    }
  },
  watch: {
    /**
     * [description] 监听图片数量变化，绑定排序事件
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    'uploadPicList': function (val) {
      this.watchUploadPicList();
    },
    /**
     * [description] 监听详情图片数量变化，绑定排序事件
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    'detailUploadPicList': function (val) {
      this.watchDetailUploadPicList();
    }
  },
  mounted() {
    this.getLatestRate()
    this.getFirstCategoryList();
  },
  methods: {
    /**
     * [getLatestRate description] 获取人民币/韩元汇率
     * @return {[type]}         [description]
     */
    getLatestRate: function () {
      commodityGetLatestRate({}).then(res => {
        let { code, data, msg } = res.data;
        if (code == 0) {
          this.latestRate = data || 1;
          this.latestRateOrigin = data || 1;
          // 同步更新显示的人民币兑韩元汇率
          this.cnyToKrwRate = (data && data > 0) ? parseFloat((1 / data).toFixed(2)) : 1.00;
          this.getDetail();
        }
      });
    },
    /**
     * [handleValidGoodsName description] 校验商品名称是否重复
     * @return {[type]} [description]
     */
    handleValidGoodsName: function () {
      let params = {
        id: this.id,
        name: this.formData.baseInfo.name
      }

      validGoodsName(params).then(res => {
        let { code, data, msg } = res;

        if (code != 0) {
          this.$message.error(msg);
        }
      }).catch(error => {

      });
    },
    /**
     * [watchUploadPicList description] 图片数量变化，绑定排序事件
     * @return {[type]} [description]
     */
    watchUploadPicList: function () {
      this.formData.baseInfo.pics = [];
      for (let i = 0; i < this.uploadPicList.length; i++) {
        // this.formData.baseInfo.pics.push(this.uploadPicList[i].response.data.url);
        this.formData.baseInfo.pics.push(this.uploadPicList[i].response.data.path);
      }

      this.$nextTick(function () {
        this.handlePicListSort();
      });
    },
    /**
     * [watchDetailUploadPicList description] 详情图片数量变化，绑定排序事件
     * @return {[type]} [description]
     */
    watchDetailUploadPicList: function () {
      this.detailPics = [];
      for (let i = 0; i < this.detailUploadPicList.length; i++) {
        // this.detailPics.push(this.detailUploadPicList[i].response.data.url);
        this.detailPics.push(this.detailUploadPicList[i].response.data.path);
      }

      this.$nextTick(function () {
        this.handleDetailPicListSort();
      });
    },
    /**
     * [getDetail description] 获取详情
     * @return {[type]} [description]
     */
    getDetail: function () {
      if (!this.id) {
        this.pageLoading = false;
        return false;
      }

      this.pageLoading = true;

      let params = {
        serviceId: this.id
      }

      serviceManageDetail(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.pageLoading = false;

          this.formData.baseInfo.name = data.name;
          this.formData.baseInfo.externalGoodsCode = data.externalGoodsCode || '';

          // 商品类目
          if (data.catList.length > 0) {
            let categoryArr = [];

            for (let i = 0; i < data.catList.length; i++) {
              let item = data.catList[i];

              categoryArr.push({
                firstCategoryId: '' + item.firstCategoryId,
                secondCategoryId: '' + item.secondCategoryId,
                secondCategoryOptions: [],
              });
            }

            this.formData.baseInfo.categoryList = categoryArr;
            this.handleGetCategoryOptions();
          }

          // 主图视频
          if (data.mainVideo) {
            let picsItemArr = data.mainVideoPath.split('/'),
              picsItemName = picsItemArr[picsItemArr.length - 1];
            this.uploadVideoList = [{
              name: picsItemName,
              percentage: 100,
              status: 'success',
              url: data.mainVideoPath,
              response: {
                data: {
                  path: data.mainVideoPath,
                  url: data.mainVideo
                }
              }
            }]
          }

          // 商品图
          let picsList = data.picList;
          let picPathList = data.picPathList;
          if (picsList.length == 0) {
            this.formData.baseInfo.pics = [];
            this.uploadPicList = [];
          } else {
            for (let i = 0; i < picsList.length; i++) {
              let picsItem = picsList[i],
                picsItemArr = picsItem.split('/'),
                picsItemName = picsItemArr[picsItemArr.length - 1];

              this.formData.baseInfo.pics.push(picsItem);
              this.uploadPicList.push({
                name: picsItemName,
                percentage: 100,
                status: 'success',
                url: picPathList[i],
                response: {
                  data: {
                    path: picsItem,
                    url: picPathList[i]
                  }
                }
              });
            }
            this.watchUploadPicList();
          }

          // 标签
          if (data.labels && data.labels.length > 0) {
            let tagsArr = [];

            for (let i = 0; i < data.labels.length; i++) {
              tagsArr.push({
                label: data.labels[i]
              })
            }

            this.formData.baseInfo.tags = tagsArr;
          }

          this.formData.baseInfo.remark = data.remark;
          this.formData.baseInfo.orderType = data.orderType;
          this.unit = data.unit || 0;
          if (this.unit == 0) {
            // 人民币
            this.formData.baseInfo.price = data.price;
            this.formData.baseInfo.nickPrice = data.linePrice;
          } else if (this.unit == 1) {
            // 韩币
            this.formData.baseInfo.price = data.koreaPrice;
            this.formData.baseInfo.nickPrice = data.lineKoreaPrice;
          }
          this.formData.baseInfo.saleNum = data.saleNum;
          this.formData.baseInfo.stock = data.stock;

          if (data.customRate) {
            this.latestRateOrigin = data.customRate
            this.latestRate = data.customRate
            // 同步更新显示的人民币兑韩元汇率
            this.cnyToKrwRate = (data.customRate > 0) ? parseFloat((1 / data.customRate).toFixed(2)) : 1.00
          }

          // 详情图
          if (data.pics.length == 0) {
            this.detailPics = [];
            this.detailUploadPicList = [];
          } else {
            for (let i = 0; i < data.pics.length; i++) {
              let picsItem = data.pics[i],
                picsItemArr = picsItem.split('/'),
                picsItemName = picsItemArr[picsItemArr.length - 1];
              let picsPathItem = data.picsPath[i];

              this.detailPics.push(picsItem);
              this.detailUploadPicList.push({
                name: picsItemName,
                percentage: 100,
                status: 'success',
                url: picsPathItem,
                response: {
                  data: {
                    path: picsItem,
                    url: picsPathItem
                  }
                }
              });
            }

            this.watchDetailUploadPicList();
          }
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        console.log(error)
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handleGetCategoryOptions description] 获取二类目、类目标签下拉列表
     * @return {[type]} [description]
     */
    handleGetCategoryOptions: function () {
      let list = this.formData.baseInfo.categoryList;

      if (list.length == 0) {
        return false;
      }

      for (let i = 0; i < list.length; i++) {
        this.handleFirstCategoryChange(i);
      }
    },
    /**
     * [handleCategoryAdd description] 添加类目
     * @return {[type]} [description]
     */
    handleCategoryAdd: function () {
      this.formData.baseInfo.categoryList.push({
        firstCategoryId: '',
        secondCategoryId: '',
        secondCategoryOptions: []
      });
    },
    /**
     * [handleCategoryDelete description] 删除类目
     * @param  {[type]} index [description]
     * @return {[type]}       [description]
     */
    handleCategoryDelete: function (index) {
      this.formData.baseInfo.categoryList.splice(index, 1);
    },
    /**
     * [getFirstCategoryList description] 获取商品类目
     * @param  {[type]} isRefresh [description] 表示这个操作是刷新
     * @return {[type]}         [description]
     */
    getFirstCategoryList: function (isRefresh) {
      this.firstCategoryOptionsLoading = true;

      let params = {
        type: 2
      }

      commodityCategoryList(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          let dataArray = data || [];

          this.firstCategoryOptions = dataArray;
          this.firstCategoryOptionsLoading = false;

          if (isRefresh) {
            this.$message({ message: '服务分类已刷新', type: 'success' });
          }
        }
      });
    },
    /**
     * [handleCommidityCategoryChange description] 监测一级类目下拉框值变化
     * @param  {[type]} val [description] 
     * @return {[type]}     [description]
     */
    handleFirstCategoryChange: function (index, type) {
      if (type == 'user') {
        this.formData.baseInfo.categoryList[index].secondCategoryId = '';
        this.formData.baseInfo.categoryList[index].categoryLabelId = '';
      }

      let categoryList = this.formData.baseInfo.categoryList,
        firstCategoryId = categoryList[index].firstCategoryId;

      let params = {
        type: 2,
        firstCategoryId: firstCategoryId
      }

      commodityCategoryList(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          let dataArray = data || [];

          categoryList[index].secondCategoryOptions = dataArray;
        }
      });
    },
    /**
     * [handleTagsAdd description] 添加标签
     * @return {[type]} [description]
     */
    handleTagsAdd: function () {
      this.formData.baseInfo.tags.push({
        label: ''
      })
    },
    /**
     * [handleTagsDelete description] 移除标签
     * @param  {[type]} index [description]
     * @return {[type]}       [description]
     */
    handleTagsDelete: function (index) {
      this.formData.baseInfo.tags.splice(index, 1);
    },
    // 价格变化
    handlePriceChange: function () {

    },
    /**
     * 人民币兑韩元汇率变化
     */
    handleCnyToKrwRateChange: function () {
      // 如果输入为空，不设置默认值，直接返回
      if (this.cnyToKrwRate === '' || this.cnyToKrwRate === null || this.cnyToKrwRate === undefined) {
        return
      }

      let cnyToKrwRate = parseFloat(this.cnyToKrwRate)
      if (cnyToKrwRate <= 0 || isNaN(cnyToKrwRate)) {
        // 如果输入值无效，保持原值不变，不进行转换
        return
      }

      // 保留两位小数
      cnyToKrwRate = parseFloat(cnyToKrwRate.toFixed(2))
      this.cnyToKrwRate = cnyToKrwRate

      // 将人民币兑韩元汇率转换为韩元兑人民币汇率
      // cnyToKrwRate: 1人民币 = cnyToKrwRate韩元
      // latestRate: 1韩元 = latestRate人民币
      // 所以 latestRate = 1 / cnyToKrwRate
      this.latestRate = 1 / cnyToKrwRate

      // 触发价格转换
      this.handleRateChange()
    },
    /**
     * 汇率变化（韩元兑人民币）
     */
    handleRateChange: function () {
      const { latestRate, latestRateOrigin } = this
      if (latestRate <= 0 || !latestRate) {
        this.latestRate = latestRateOrigin
        // 同步更新显示的人民币兑韩元汇率
        this.cnyToKrwRate = latestRateOrigin > 0 ? parseFloat((1 / latestRateOrigin).toFixed(2)) : 1.00
      } else {
        // 同步更新显示的人民币兑韩元汇率
        this.cnyToKrwRate = parseFloat((1 / latestRate).toFixed(2))
      }

      const { unit } = this
      const { price, koreaPrice } = this.formData.baseInfo
      if (unit == 1) {
        // 韩元
        this.formData.baseInfo.price = (koreaPrice * this.latestRate).toFixed(2)
      } else {
        // 人民币
        this.formData.baseInfo.koreaPrice = Math.ceil(price / this.latestRate)
      }
    },
    /**
     * 价格单位切换
     */
    handlePriceUnitSwitch() {
      const { latestRate, formData, unit } = this
      const { price, koreaPrice } = formData.baseInfo
      if (unit == 1) {
        // 韩元
        formData.baseInfo.koreaPrice = Math.ceil(price / latestRate)
      } else {
        // 人民币
        formData.baseInfo.price = (koreaPrice * latestRate).toFixed(2)
      }
    },
    /**
     * [handleVideosBeforeUpload description] 视频上传之前
     * @param  {[type]} file [description]
     * @return {[type]}      [description]
     */
    handleVideosBeforeUpload: function (file) {
      let fileName = file.name,
        fileNameArr = fileName.split('.'),
        fileType = fileNameArr[fileNameArr.length - 1],
        supportArr = ['mp4', 'mov'];

      if (supportArr.indexOf(fileType) == -1) {
        this.$message.error('请上传MP4、MOV格式的图片');
        return false;
      }
    },
    handleVideosSuccess: function (response, file, fileList) {
      this.uploadVideoList = fileList;
    },
    handleVideosError: function (err, file, fileList) {
      this.$message.error('视频上传失败');
      this.uploadVideoList = fileList;
    },
    handleVideosExceed: function (files, fileList) {
      this.$message.error('视频最多上传' + this.videosLimit + '个');
    },
    handleVideosRemove: function (file, fileList) {
      this.uploadVideoList = [];
    },
    handleVideosPreview: function (file) {
      this.previewVideoDialogUrl = this.uploadVideoList[0].response.data.path;
      this.previewVideoDialogShow = true;
    },
    /**
     * [handlePicturesBeforeUpload description] 图片上传之前
     * @param  {[type]} file [description]
     * @return {[type]}      [description]
     */
    handlePicturesBeforeUpload: function (file) {
      let fileName = file.name,
        fileNameArr = fileName.split('.'),
        fileType = fileNameArr[fileNameArr.length - 1],
        supportArr = ['jpg', 'jpeg', 'png'];

      if (supportArr.indexOf(fileType) == -1) {
        this.$message.error('请上传jpg、jpeg、png格式的图片');
        return false;
      }
    },
    handlePicturesSuccess: function (response, file, fileList) {
      this.uploadPicList = fileList;
    },
    handlePicturesError: function (err, file, fileList) {
      this.$message.error('图片上传失败');
      this.uploadPicList = fileList;
    },
    handlePicturesExceed: function (files, fileList) {
      this.$message.error('图片最多上传' + this.picsLimit + '张');
    },
    handlePicturesRemove: function (file, fileList) {
      this.uploadPicList = fileList;
    },
    handlePicturesPreview: function (file) {
      this.previewDialogImageUrl = file.url;
      this.previewDialogShow = true;
    },
    /**
     * [handlePicListSort description] 图片列表排序
     * @return {[type]} [description]
     */
    handlePicListSort: function () {
      let picLI = document.getElementsByClassName('pics-box-goods')[0].getElementsByClassName('el-upload-list')[0].getElementsByTagName('li');

      for (let i = 0; i < picLI.length; i++) {
        let picLIItem = picLI[i];

        picLIItem.draggable = true;
        picLIItem.setAttribute('data-index', i);
        picLIItem.style.cursor = 'all-scroll';

        picLIItem.removeEventListener('dragstart', this.handlePicLIDragStart);
        picLIItem.addEventListener('dragstart', this.handlePicLIDragStart, false);

        picLIItem.removeEventListener('dragover', this.handlePicLIDragover);
        picLIItem.addEventListener('dragover', this.handlePicLIDragover, false);

        picLIItem.removeEventListener('drop', this.handlePicLIDrop);
        picLIItem.addEventListener('drop', this.handlePicLIDrop, false);
      }
    },
    /**
     * [handlePicLIDragStart description] 拖动开始
     * @param  {[type]} ev [description]
     * @return {[type]}    [description]
     */
    handlePicLIDragStart: function (ev) {
      ev.dataTransfer.setData('index', ev.target.dataset.index);
    },
    /**
     * [handlePicLIDragover description] 必须存在，否则不会触发drop事件
     * @param  {[type]} ev [description]
     * @return {[type]}    [description]
     */
    handlePicLIDragover: function (ev) {
      ev.preventDefault();
    },
    /**
     * [handlePicLIDrop description] 拖动结束
     * @param  {[type]} ev [description]
     * @return {[type]}    [description]
     */
    handlePicLIDrop: function (ev) {
      ev.preventDefault();

      let originalIndex = ev.dataTransfer.getData('index'),
        liNode = this.handleGetLINode(ev.target),
        targetIndex = liNode.getAttribute('data-index');

      if (originalIndex == targetIndex) { // 原地释放
        return false;
      }

      // 将移动的对象插入目标对象之前
      let originalObject = this.uploadPicList.splice(originalIndex, 1);
      this.uploadPicList.splice(targetIndex, 0, originalObject[0]);

      this.formData.baseInfo.pics = [];
      for (let i = 0; i < this.uploadPicList.length; i++) {
        // this.formData.baseInfo.pics.push(this.uploadPicList[i].response.data.url);
        this.formData.baseInfo.pics.push(this.uploadPicList[i].response.data.path);
      }
    },
    /**
     * [handleGetLINode description] 循环获取目标dom的标签名，直到找到li，返回该li对象
     * @param  {[type]} ob [description]
     * @return {[type]}    [description]
     */
    handleGetLINode: function (ob) {
      if (ob.tagName == 'LI') {
        return ob;
      } else {
        return this.handleGetLINode(ob.parentNode);
      }
    },
    /**
     * [handleDetailPicturesBeforeUpload description] 图片上传之前
     * @param  {[type]} file [description]
     * @return {[type]}      [description]
     */
    handleDetailPicturesBeforeUpload: function (file) {
      let fileName = file.name,
        fileNameArr = fileName.split('.'),
        fileType = fileNameArr[fileNameArr.length - 1],
        supportArr = ['jpg', 'jpeg', 'png'];

      if (supportArr.indexOf(fileType) == -1) {
        this.$message.error('请上传jpg、jpeg、png格式的图片');
        return false;
      }
    },
    handleDetailPicturesSuccess: function (response, file, fileList) {
      this.detailUploadPicList = fileList;
    },
    handleDetailPicturesError: function (err, file, fileList) {
      this.$message.error('图片上传失败');
      // this.detailUploadPicList = fileList;
    },
    handleDetailPicturesRemove: function (file, fileList) {
      this.detailUploadPicList = fileList;
    },
    handleDetailPicturesPreview: function (file) {
      this.previewDialogImageUrl = file.url;
      this.previewDialogShow = true;
    },
    /**
     * [handleDetailPicListSort description] 详情图片列表排序
     * @return {[type]} [description]
     */
    handleDetailPicListSort: function () {
      let picLI = document.getElementsByClassName('pics-box-detail')[0].getElementsByClassName('el-upload-list')[0].getElementsByTagName('li');

      for (let i = 0; i < picLI.length; i++) {
        let picLIItem = picLI[i];

        picLIItem.draggable = true;
        picLIItem.setAttribute('data-index', i);
        picLIItem.style.cursor = 'all-scroll';

        picLIItem.removeEventListener('dragstart', this.handleDetailPicLIDragStart);
        picLIItem.addEventListener('dragstart', this.handleDetailPicLIDragStart, false);

        picLIItem.removeEventListener('dragover', this.handleDetailPicLIDragover);
        picLIItem.addEventListener('dragover', this.handleDetailPicLIDragover, false);

        picLIItem.removeEventListener('drop', this.handleDetailPicLIDrop);
        picLIItem.addEventListener('drop', this.handleDetailPicLIDrop, false);
      }
    },
    /**
     * [handleDetailPicLIDragStart description] 拖动开始
     * @param  {[type]} ev [description]
     * @return {[type]}    [description]
     */
    handleDetailPicLIDragStart: function (ev) {
      ev.dataTransfer.setData('index', ev.target.dataset.index);
    },
    /**
     * [handleDetailPicLIDragover description] 必须存在，否则不会触发drop事件
     * @param  {[type]} ev [description]
     * @return {[type]}    [description]
     */
    handleDetailPicLIDragover: function (ev) {
      ev.preventDefault();
    },
    /**
     * [handleDetailPicLIDrop description] 拖动结束
     * @param  {[type]} ev [description]
     * @return {[type]}    [description]
     */
    handleDetailPicLIDrop: function (ev) {
      ev.preventDefault();

      let originalIndex = ev.dataTransfer.getData('index'),
        liNode = this.handleGetLINode(ev.target),
        targetIndex = liNode.getAttribute('data-index');

      if (originalIndex == targetIndex) { // 原地释放
        return false;
      }

      // 将移动的对象插入目标对象之前
      let originalObject = this.detailUploadPicList.splice(originalIndex, 1);
      this.detailUploadPicList.splice(targetIndex, 0, originalObject[0]);

      this.detailPics = [];
      for (let i = 0; i < this.detailUploadPicList.length; i++) {
        // this.detailPics.push(this.detailUploadPicList[i].response.data.url);
        this.detailPics.push(this.detailUploadPicList[i].response.data.path);
      }
    },
    /**
     * [handleDetailGetLINode description] 循环获取目标dom的标签名，直到找到li，返回该li对象
     * @param  {[type]} ob [description]
     * @return {[type]}    [description]
     */
    handleDetailGetLINode: function (ob) {
      if (ob.tagName == 'LI') {
        return ob;
      } else {
        return this.handleGetLINode(ob.parentNode);
      }
    },
    /**
     * [handleChangeStep description] 改变当前步骤
     * @param  {[type]} step [description]
     * @return {[type]}      [description]
     */
    handleChangeStep: function (step) {
      if (this.step == step) {
        return false;
      }

      if (step == 2) {
        if (this.handleValidateForm()) {
          this.step = step;
        }
      } else if (step == 1) {
        this.step = step;
      }
    },
    /**
     * [handleFormSubmit description] 保存数据
     * @return {[type]} [description]
     */
    handleFormSubmit: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 详情
          if (this.detailPics.length == 0) {
            this.$message.error('请上传商品详情图');
            return false;
          }

          let formData = this.formData,
            baseInfo = formData.baseInfo;

          // 类目
          let categoryArr = [];
          for (let i = 0; i < baseInfo.categoryList.length; i++) {
            let item = baseInfo.categoryList[i];

            categoryArr.push({
              firstCategoryId: item.firstCategoryId,
              secondCategoryId: item.secondCategoryId
            })
          }

          // 标签
          let tagsArr = [];
          if (baseInfo.tags.length > 0) {
            for (let i = 0; i < baseInfo.tags.length; i++) {
              let item = baseInfo.tags[i];

              if (item.label) {
                tagsArr.push(item.label);
              }
            }
          }

          // this.submitLoading = true;

          let params = {
            id: this.id,
            name: baseInfo.name, // 商品名称
            externalGoodsCode: baseInfo.externalGoodsCode, // 尘峰项目编码
            catList: categoryArr, // 类目
            mainVideo: this.uploadVideoList[0] ? this.uploadVideoList[0].response.data.url : '',
            picList: baseInfo.pics, // 商品图
            labels: tagsArr, // 标签
            remark: baseInfo.remark, // 备注
            orderType: baseInfo.orderType, // 预约方式
            unit: this.unit,
            saleNum: baseInfo.saleNum,
            stock: parseInt(baseInfo.stock || 0), // 库存
            pics: this.detailPics, // 详情图片
            customRate: this.latestRate
          }

          if (this.unit === 0) {
            // 人民币
            params.price = baseInfo.price || ''
            params.linePrice = baseInfo.nickPrice || ''
          } else if (this.unit === 1) {
            // 韩币
            params.koreaPrice = baseInfo.price || ''
            params.lineKoreaPrice = baseInfo.nickPrice || ''
          }
          serviceManageSaveOrUpdate(params).then(res => {
            this.submitLoading = false;

            let { code, data, msg } = res;

            if (code == 0) {
              this.$message({ message: '保存成功', type: 'success' });

              this.$router.push({ path: '/service/manage/list' });
            } else {
              this.$message.error(msg);
            }
          }).catch(error => {
            this.submitLoading = false;
            this.$message.error('服务器异常');
          });
        } else {
          return false;
        }
      });
    },
    /**
     * [handleValidateForm description] 表单校验
     * @return {[type]} [description]
     */
    handleValidateForm: function () {
      let baseInfo = this.formData.baseInfo;

      // 项目名称
      if (!baseInfo.name) {
        this.$message.error('请输入项目名称');
        return false;
      }

      // 分类
      let categoryList = baseInfo.categoryList;
      if (categoryList.length == 0) {
        this.$message.error('请添加分类');
        return false;
      }
      for (let i = 0; i < categoryList.length; i++) {
        let item = categoryList[i];

        if (!item.firstCategoryId || !item.secondCategoryId) {
          this.$message.error('请选择分类');
          return false;
        }
      }

      // 项目图
      if (baseInfo.pics.length == 0) {
        this.$message.error('请上传项目图片');
        return false;
      }

      // 标签
      if (baseInfo.tags.length > 0) {
        for (let i = 0; i < baseInfo.tags.length; i++) {
          let item = baseInfo.tags[i];

          if (item.label && item.label.length < 2) {
            this.$message.error('标签名长度需2-8个中文字符');
            return false;
          }
        }
      }

      // 备注
      if (baseInfo.remark == '') {
        this.$message.error('请输入备注');
        return false;
      }

      // 预约方式
      if (baseInfo.orderType == '') {
        this.$message.error('请输入预约方式');
        return false;
      }

      // 价格
      if (baseInfo.price === '') {
        this.$message.error('请输入价格');
        return false;
      }

      // 库存
      if (baseInfo.stock === '') {
        this.$message.error('请输入库存');
        return false;
      }

      return true;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

.steps-bar {
  border-radius: 48px;
  overflow: hidden;
  background: $colorTitleBg;

  .steps-item {
    background: transparent;
    font-size: $baseFS;
    line-height: 48px;
    text-align: center;

    &.active {
      background: $themeColor;
      color: $colorWhite;
      border-radius: 48px;
    }
  }
}

.type-wrap {
  font-size: 0;
  text-align: left;

  .type-item {
    position: relative;
    display: inline-block;
    margin-left: 80px;
    padding: 10px 20px;
    border: 1px solid #DDDDDD;
    border-radius: 2px;
    cursor: pointer;

    &+.type-item {
      margin-left: 10px;
    }

    .label {
      font-size: 12px;
      line-height: 17px;
      color: #222;
    }

    .tips {
      margin-top: 4px;
      font-size: 12px;
      line-height: 17px;
      color: rgba(#222, .5);
    }

    &.active {
      border-color: $themeColor;

      .label {
        color: $themeColor;
      }

      &::before {
        content: "";
        @include position(absolute, 3, 0, 0, none, none);
        width: 16px;
        height: 16px;
        @include backgroundImage('../../../assets/icon_16_2@2x.png', no-repeat, right, center, auto, 16px);
      }
    }
  }
}

.radio-block {
  .tips {
    margin-left: 24px;
  }
}

.checkbox-block,
.switch-block {

  &+.checkbox-block,
  &+.switch-block {
    margin-left: 20px;
  }
}

.grey-inline-block {
  display: inline-block;
  background: $colorPageBg;
}

.paticular-table {
  background-color: transparent;

  &::before {
    display: none;
  }

  .el-table__header-wrapper {}

  ::v-deep .el-table__body-wrapper {
    .el-table__body {
      .el-table__row {
        background-color: transparent;

        td {
          padding: 5px 0;
          border-bottom-color: #ebeef5;
          /*border-bottom-color: transparent;*/
        }
      }
    }
  }
}

.pics-box {
  ::v-deep .el-upload-list--picture-card {
    .el-upload-list__item {
      position: relative;
      width: 100px;
      height: 100px;
      border-radius: 2px;
      transition: none;

      .el-upload-list__item-thumbnail {
        @include position(absolute, none, 50%, none, none, 50%);
        @include translate(-50%, -50%, 0);
      }

      .el-progress {
        width: 80px;
        height: 80px;

        .el-progress-circle {
          width: 80px !important;
          height: 80px !important;
        }
      }

      .el-icon-close-tip {
        display: none;
      }

      .el-upload-list__item-actions {
        cursor: move;
      }
    }
  }

  ::v-deep .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 98px;
    border-radius: 2px;

    .el-upload-dragger {
      width: 98px;
      height: 98px;
      border: none;

      .el-icon-plus {
        font-size: $baseFS;
      }
    }
  }

  .video-box {
    .video-item {
      position: relative;
      width: 100px;
      height: 100px;

      .video {
        width: 98px;
        height: 98px;
        border: 1px solid #c0ccda;
      }

      .mask {
        @include position(absolute, 1, 0, 0, 0, 0);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background: rgba(#000, .5);
        opacity: 0;
        transition: opacity .3s;

        i {
          font-size: 20px;
          color: #FFF;
          cursor: pointer;

          &+i {
            margin-left: 15px;
          }
        }
      }

      &:hover {
        .mask {
          opacity: 1;
          transition: opacity .3s;
        }
      }
    }
  }
}

// .pics-box-detail{
//     ::v-deep .el-upload-list{
//         .el-upload-list__item{
//             &.is-success{
//                 width: 500px;
//                 height: 200px;
//             }
//         }
//     }
// }

.particular-toolbar {
  padding: 8px 10px;
}

.sort-item {
  display: inline-block;
  padding: 0 12px;
  margin-right: 10px;
  line-height: 28px;
  white-space: nowrap;
  background-color: #EEE;
  font-size: $smallFS;
  color: $textColor;
  border-radius: 2px;

  &:hover,
  &:focus {
    background-color: rgba(#5BCFE6, .2);
  }
}

.delete-block-category {
  margin-left: 70px;
  margin-bottom: 18px;

  .el-form-item {
    margin-left: -70px;
    margin-bottom: 0;

    &+.el-form-item {
      margin-top: 8px;
    }
  }
}

.specification-value-item {
  float: left;

  .specification-pics-box {
    position: relative;
    margin-bottom: 10px;

    .pics-box {
      width: 100px;
      height: 100px;
      overflow: hidden;
    }
  }
}

.select-loading {
  @include position(absolute, 10, 3px, 2px, 3px, 0);
  display: block;
  background: transparent;
  width: 100%;
  border: none;
  pointer-events: inherit;

  /*&::before{
            display: none;
        }*/

  &::after {
    border: none;
  }

  ::v-deep .el-icon-loading {
    color: $themeColor;
  }
}
</style>
